import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import AddIcon from '~/assets/icons/svgs/add.svg?react';
import ImageIcon from '~/assets/icons/svgs/image.svg?react';
import PencilIcon from '~/assets/icons/svgs/pencil.svg?react';
import { Button } from '~/components/ui/button';
import { COLORS } from '~/styles/colors';

import {
  StyledAdd,
  StyledInput,
  StyledUploadContainer,
  StyledUploadedLogo,
  StyledUploadedLogoContainer,
  StyledUploadedLogoWrapper,
} from './styled';

type ImageUploaderProps = {
  onUploadImage?: (event: ChangeEvent<HTMLInputElement>) => void;
  image?: string;
  onDeleteImage?: () => void;
  withUploaderModal?: boolean;
  onOpenUploaderModal?: () => void;
};
export default function ImageUploader({
  onUploadImage,
  image,
  onDeleteImage,
  withUploaderModal = false,
  onOpenUploaderModal,
}: ImageUploaderProps) {
  const { t } = useTranslation();

  return (
    <StyledUploadedLogoWrapper>
      <StyledUploadContainer $isUploadedLogo={!!image} onClick={onOpenUploaderModal}>
        {image ? (
          <StyledUploadedLogoContainer>
            <StyledUploadedLogo src={image} alt="uploaded" />
          </StyledUploadedLogoContainer>
        ) : (
          <ImageIcon />
        )}
        <StyledAdd $isUploadedLogo={!!image}>{image ? <PencilIcon /> : <AddIcon />}</StyledAdd>
        {!withUploaderModal && <StyledInput type="file" accept="image/*" onChange={onUploadImage} />}
      </StyledUploadContainer>
      {image && (
        <Button
          type="primary-outlined"
          borderColor={COLORS.error}
          color={COLORS.error}
          onClick={onDeleteImage}
          size="xs"
        >
          {t('buttons:delete')}
        </Button>
      )}
    </StyledUploadedLogoWrapper>
  );
}
